// extracted by mini-css-extract-plugin
export var form = "ContactPageForm-module--form--vENi5";
export var formDescription = "ContactPageForm-module--form-description--8qvhd";
export var formHeadline = "ContactPageForm-module--form-headline--F1azn";
export var formRequiredFieldText = "ContactPageForm-module--form-required-field-text--ZbSPo";
export var formSubtitle = "ContactPageForm-module--form-subtitle--9C1v2";
export var formWrapper = "ContactPageForm-module--form-wrapper--nNuyO";